import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import { Observable} from 'rxjs';
import {BankAccount} from '../interface/bank-account';
import {Bank} from "../interface/bank";
import {environment} from "../../../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class BankAccountService {
  private baseUrl = environment.apiBaseUrl;
  constructor(private http: HttpClient) { }


  get(id: number): Observable<any>{
    return this.http.get(`${this.baseUrl}/get/bank-account/${id}`);
  }

  getCollection(): Observable<BankAccount[]>{
    return this.http.get<BankAccount[]>(`${this.baseUrl}/get/bank-account`);
  }

  getEnableCollection(): Observable<BankAccount[]>{
    return this.http.get<BankAccount[]>(`${this.baseUrl}/get/enable/bank-account`);
  }

  post(data: BankAccount): Observable<any>{
    return this.http.post<BankAccount>(`${this.baseUrl}/create/bank-account`, data);
  }

  update(id: number, data: BankAccount): Observable<any>{
    return this.http.put<BankAccount>(`${this.baseUrl}/edit/bank-account/${id}`, data);
  }

  delete(id: number): Observable<BankAccount>{
    return this.http.delete<BankAccount>(`${this.baseUrl}/delete/bank-account/` + id);
  }

  deleteMultiple(ids: number[]): Observable<BankAccount[]>{
    const options = {body: ids};
    return this.http.delete<BankAccount[]>(`${this.baseUrl}/delete/bank-account`, options);
  }

  getBankAccount(): Observable<BankAccount[]>{
    return this.http.get<BankAccount[]>(`${this.baseUrl}/treasury/dashboard/bank-account`);
  }

}
